import useCertificatesQuery from './queries/useCertificatesQuery';
import useGetCorporateCardList from './queries/useGetCorporateCardList';
import { useCompanyId } from './useCompanyId';

const useCheckOnboardStatus = () => {
  const { companyId } = useCompanyId();
  const { data: certificate } = useCertificatesQuery(companyId);
  const certificateList = certificate?.Data?.data?.certificates || [];
  const { data: card } = useGetCorporateCardList(companyId);

  const certificateRegistered =
    certificateList.length > 0 &&
    certificateList.some((cert) => {
      return cert.organizationList.find((org) => org.organizationDataCategory === 'REVENUE');
    }) &&
    certificateList.some((cert) => {
      return cert.organizationList.filter((org) => org.organizationType === 'BK').length > 0;
    });

  const cardData = card?.Data?.data?.content || [];
  const cardRegistered = cardData.length > 0;

  return {
    certificateRegistered,
    cardRegistered,
  };
};

export default useCheckOnboardStatus;
